// packages/url/src/get-query-string.ts
function getQueryString(url) {
  let query;
  try {
    query = new URL(url, "http://example.com").search.substring(1);
  } catch {
  }
  if (query) {
    return query;
  }
}
export {
  getQueryString
};
//# sourceMappingURL=get-query-string.mjs.map
